module.exports = __webpack_public_path__ + "static/img/1en.235efca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/xiaomi/1en.png
// module id = gyuf
// module chunks = 0